import { useState } from "react";
import { Form } from "react-bootstrap";

import { RespostaType } from "../../entities/QuestionnaireEntity";
import { QuestionEntity } from "../../entities/QuestionEntity";

type FormTextareaProps = {
	pergunta: QuestionEntity;
	resposta: RespostaType | null;
	onChange: (value: RespostaType) => void;
};

export default function FormTextarea(props: FormTextareaProps) {
	const [value, setValue] = useState(props.resposta);

	function handleChange(value: string) {
		let data = { questionId: props.pergunta.id!, text: value };
		setValue(data);
		props.onChange(data);
	}

	return (
		<Form.Control
			type="number"
			as={"textarea"}
			rows={5}
			className="bg-white"
			value={value?.text}
			onChange={(e) => {
				handleChange(e.currentTarget.value);
			}}
			autoFocus={true}
		/>
	);
}
